export default (initialState = {}) => {
  return () => {
    return {
      pincode: "",
      state: "",
      state_code: "",
      city: "",
      address_line: "",
      type_display: "Dispatch",
      type: "dispatch",
      is_primary: false,
      user_id: "",
      ...initialState,
    };
  };
};
